/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import type { PayloadAction, Draft } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { AuthStore, LoginPayload, SetAuthPayload } from './types';

export const initialState: AuthStore = {
  isLoggedIn: false,
  credentials: undefined,
};

export const slice = createSlice({
  initialState,
  name: 'auth',
  reducers: {
    setCredentials: (
      draft: Draft<AuthStore>,
      action: PayloadAction<SetAuthPayload>,
    ) => {
      draft.credentials = action.payload.credentials;
    },

    login: (draft: Draft<AuthStore>, action: PayloadAction<LoginPayload>) => {
      draft.isLoggedIn = action.payload.isLoggedIn;
    },

    logout: (draft: Draft<AuthStore>) => {
      draft.isLoggedIn = false;
      draft.credentials = undefined;
    },
  },
});

export const { reducer: authReducer, actions: authActions } = slice;

export type AuthActions =
  | ReturnType<typeof authActions.setCredentials>
  | ReturnType<typeof authActions.login>
  | ReturnType<typeof authActions.logout>;
